import {
	COLOR_SEARCH_PARAM,
	DEFAULT_LOOK_ID,
	LOOK_SEARCH_PARAM,
} from 'product/constants/constants'
import type { Product, ProductColor } from 'product/types/Product'
import { env } from 'utils/envManager/envManager'

interface GetProductUrlProps {
	product: Product
	colorId: ProductColor['id']
	countryISO: string
	languageISO: string
	lookId?: string
}

export function getProductUrl({
	product,
	colorId,
	lookId,
	countryISO,
	languageISO,
}: GetProductUrlProps): string {
	const color = product.colors.find((c) => c.id === colorId)
	const productId = color?.relatedProductId ?? product.id

	const baseBackupUrl = `/${countryISO.toLowerCase()}/${languageISO.toLowerCase()}/p/${productId}`
	const baseUrl =
		color?.relatedProductUrl ||
		(!color?.relatedProductId && product.url) ||
		baseBackupUrl

	const productUrl = new URL(baseUrl, env.NEXT_PUBLIC_CURRENT_ORIGIN)

	// Color is optional since we are doing a find by color id
	if (product.colors.length > 1 && color?.id) {
		const colorByDefault: ProductColor | undefined = product.colors.find(
			(productColor: ProductColor) => !productColor.relatedProductId
		)
		if (color.id !== colorByDefault?.id) {
			productUrl.searchParams.set(COLOR_SEARCH_PARAM, color.id)
		}
	}

	if (lookId && lookId !== DEFAULT_LOOK_ID) {
		productUrl.searchParams.set(LOOK_SEARCH_PARAM, lookId)
	}

	return productUrl.pathname + productUrl.search
}
